import styled from "styled-components";

export const ListStyle = styled.div`
  
`;
